import './styles.scss';

import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

export default class VideoCaseStudyHero extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };

    render() {
        const { data } = this.props;

        return (
            <div className="component-video-case-study-hero">
                <div className="v3-container">
                    <header className="hero-header">
                        <h2 className="page-title">{data.title}</h2>
                        <div className="logos">
                            <a href={data.logoHref} target="_blank">
                                <img src={data.logo} />
                            </a>
                        </div>
                    </header>
                </div>
                <img className="background" src={require('Theme/images/videoCaseStudies/videoCaseStudy-hero-top.png')} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/videoCaseStudy/Hero/index.js